// extracted by mini-css-extract-plugin
export default {"AccordionContainer":"Accordion_AccordionContainer__r82ap"};